import React from 'react';
import { PortableText } from '@portabletext/react';

const portableTextComponents = {
  block: {
    normal: ({ children }) => <p className="mb-4 text-gray-600 leading-relaxed">{children}</p>,
    h2: ({ children }) => <h2 className="mt-8 mb-4 text-2xl font-heading font-bold text-gray-800">{children}</h2>,
    h3: ({ children }) => <h3 className="mt-8 mb-4 text-xl font-heading font-semibold text-gray-800">{children}</h3>,
    h4: ({ children }) => <h4 className="mt-6 mb-3 text-lg font-heading font-semibold text-gray-800">{children}</h4>,
  },
  list: {
    bullet: ({ children }) => <ul className="mb-4 list-disc space-y-2 pl-6 text-gray-600">{children}</ul>,
    number: ({ children }) => <ol className="mb-4 list-decimal space-y-2 pl-6 text-gray-600">{children}</ol>,
  },
  listItem: {
    bullet: ({ children }) => <li>{children}</li>,
    number: ({ children }) => <li>{children}</li>,
  },
  marks: {
    strong: ({ children }) => <strong className="font-semibold text-gray-800">{children}</strong>,
    em: ({ children }) => <em className="italic">{children}</em>,
    link: ({ children, value }) => (
      <a
        href={value?.href}
        target="_blank"
        rel="noopener noreferrer"
        className="text-primary-500 underline decoration-primary-200 underline-offset-4 hover:text-primary-600"
      >
        {children}
      </a>
    ),
  },
};

const PortableTextContent = ({ value }) => {
  if (!value || !Array.isArray(value)) {
    return null;
  }

  return <PortableText value={value} components={portableTextComponents} />;
};

export default PortableTextContent;
